<template>
	<div class="card shadow" id="signup-form">
		<div class="card-body text-center ml-1 mr-1">
			<h3 class="mt-3 mb-5">Deploy in seconds</h3>

            <input class="form-control form-control-lg mb-3" type="text" placeholder="Full name">
            <input class="form-control form-control-lg mb-3" type="email" placeholder="Email address">
            <input class="form-control form-control-lg mb-4" type="password" placeholder="Create a password">

            <button class="btn btn-lg btn-primary btn-block shadow-sm mb-3">
                Create your account
            </button>

            <div class="d-flex mb-3">
                <hr class="my-auto flex-fill mt-2">
                <p class="text-muted my-auto ml-3 mr-3" style="font-size: 20;">or sign up with</p>
                <hr class="my-auto flex-fill mt-2">
            </div>

            <div class="d-flex mb-4">
                <button class="btn btn-lg btn-light flex-fill mr-1">
                    <i class="la la-google-plus mr-1"></i> Google
                </button>

                <button class="btn btn-lg btn-light flex-fill ml-1">
                    <i class="la la-github mr-1"></i> Github
                </button>
            </div>
            <small class="text-muted">By signing up you agree to the <router-link to="#"><u>Terms of Service</u></router-link></small>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
h3 {
    color: rgb(4, 21, 56);
    font-weight: 700;
}

.btn-light {
    background: rgb(250, 250, 250);
    border: 1px solid rgb(230, 230, 230);
}

.btn-primary {
    background: rgb(19, 110, 251);
    font-size: 12pt;
    font-weight: 600;
    padding-top: 0.6em;
    padding-bottom: 0.6em;
}

.card {
    width: 80%;
    margin-top: 30vh;
}

input {
    border: 1px solid rgb(230, 230, 230);
    box-shadow: none !important;
}

input::placeholder {
    color: rgb(74, 80, 102);
    font-size: 12pt;
    font-weight: 300;
}
</style>